import { getSharedConfig as getSharedConfigInternal } from '@eversports/react-app-base/get-config'

import { SharedConfig } from './config'

// eslint-disable-next-line
export const getSharedConfig = () => getSharedConfigInternal<SharedConfig>()
